import React from 'react';
import { Typography } from '@material-ui/core';

import { useStyles } from './styles';

interface IInfoCard {
  title: string;
  content: any;
}

const InfoCard: React.FC<IInfoCard> = ({ title, content }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography className={classes.title} variant="h3" gutterBottom>
        {title}
      </Typography>
      <Typography
        className={classes.contentText}
        color="textPrimary"
        variant="body1"
      >
        {content}
      </Typography>
    </div>
  );
};

export default InfoCard;
